import { takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { GetFaqActionTypes, GetFaqNotificationsActionTypes,GetFaqOnboardingMessageActionTypes } from './types';
import { getFaqActions, getFaqNotificationsActions,getFaqOnboardingMessageActions } from './actions';
import FaqService from '../../services/faq.service';
import { GetFaqRequest } from '../../models/faq/GetFaqRequest';
import { FaqType } from '../../models/faq/FaqType';

export default function* faqSaga() {
    yield takeEvery(GetFaqActionTypes.REQUEST, getFaqRequest);
    yield takeEvery(GetFaqNotificationsActionTypes.REQUEST, getFaqNotificationsRequest);
    yield takeEvery(GetFaqOnboardingMessageActionTypes.REQUEST, getFaqOnboardingMessageRequest);
}

function* getFaqRequest(action: Action<GetFaqRequest>) {
    yield sagaUtility(action.payload, FaqService.get, getFaqActions.success, getFaqActions.failure);
}

function* getFaqNotificationsRequest(action: Action<undefined>) {
    const request = { pageNumber: 1, pageSize: 10, type: FaqType.Notification } as GetFaqRequest;
    yield sagaUtility(request, FaqService.get, getFaqNotificationsActions.success, getFaqNotificationsActions.failure);
}

function* getFaqOnboardingMessageRequest(action: Action<undefined>) {
    const request = { pageNumber: 1, pageSize: 10, type: FaqType.OnboardingMessage } as GetFaqRequest;
    yield sagaUtility(request, FaqService.get, getFaqOnboardingMessageActions.success, getFaqOnboardingMessageActions.failure);
}
